var exports = {
  "kL": "ChannelWebhooksTab.module__container___dk1aSk",
  "wx": "ChannelWebhooksTab.module__header___dk1aSk",
  "h_": "ChannelWebhooksTab.module__description___dk1aSk",
  "UD": "ChannelWebhooksTab.module__buttonContainer___dk1aSk",
  "dc": "ChannelWebhooksTab.module__spinnerContainer___dk1aSk",
  "Xb": "ChannelWebhooksTab.module__messageBox___dk1aSk",
  "PQ": "ChannelWebhooksTab.module__webhooksList___dk1aSk",
  "wp": "ChannelWebhooksTab.module__followedSection___dk1aSk",
  "Gf": "ChannelWebhooksTab.module__sectionTitle___dk1aSk",
  "yV": "ChannelWebhooksTab.module__sectionDescription___dk1aSk",
};

module.exports = exports;
